export enum ConsultationTypes {
  Asynchronous = 'Async',
  Scheduled = 'Scheduled',
}
